import {Skeleton, Typography} from "@mui/material";
import {AccessTime, Category} from "@mui/icons-material";
import React from "react";

const MaintenanceReadMaintenanceType = ({isLoading, dataUpdate}) => {
  return (
    <>
      {!isLoading ?
        <Typography
          sx={{marginBottom: '0.5rem', alignItems: 'center', display: 'flex'}}
        >
          <Category sx={{mr: '0.5rem'}}/>
          <b>Tipo de Manutenção: </b>&nbsp;
          {dataUpdate?.category === "PERIODIC" && "Recorrente"}
          {dataUpdate?.category === "ONLY" && "Uma vez, sem recorrência"}
          {dataUpdate?.category === "NOW" && "Urgente"}
        </Typography>
        :
        <Skeleton
          variant="rounded"
          animation="pulse"
          height={24}
          sx={{marginBottom: '0.5rem'}}
        />
      }
    </>
  )
}

export default MaintenanceReadMaintenanceType